import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './RecurringContributeWhatsNext.scss';

import config from '../../../../config/config';
import ConfirmationExitBox from '../../ConfirmationExitBox';
import viewTransactionsIcon from 'src/assets/images/view-transactions.svg';
import oneTimeTransactionIcon from 'src/assets/images/one-time-transaction.svg';
import sellDashboard from 'src/assets/images/sell-dashboard.svg';
import { getCollegePlanType } from '../../../../redux/modules/productTypes/productType.selectors';

export const IRAAutoMaxWhatsNext = () => (
  <div className="recurring-contribute-whats-next-exit-container">
    <div>
      <div className="recurring-contribute-whats-next-exit-heading">
        What's next?
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-another-trade'}
            className={'e2e-confirm-another-trade'}
            heading={'View Your Automatic Transactions'}
            subHeading={'Set up or manage existing recurring transactions.'}
            image={viewTransactionsIcon}
            exitLocation={`${config.url}/usis/transactions/automatic`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-gifting-portal'}
            className={'e2e-confirm-gifting-portal'}
            heading={'Make a One-Time Transaction'}
            subHeading={'Buy, sell, or exchange your investments.'}
            image={oneTimeTransactionIcon}
            exitLocation={`${config.url}/usis/transactions/landing`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-view-dashboard'}
            className={'e2e-confirm-view-dashboard'}
            heading={'View Your Dashboard'}
            subHeading={`Review your portfolio and track how your investments are performing.`}
            image={sellDashboard}
            exitLocation={`${config.url}/usis/my-accounts/dashboard`}
          />
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = (state) => {
  return {
    collegeConfirmType: getCollegePlanType(state),
  };
};

export default compose(connect(mapStateToProps))(IRAAutoMaxWhatsNext);
